<div class="abgang-liste-root" [class.abgang-liste-root--dialog]="alsDialog">
    <div class="abgang-hit-legend">
        <span class="abgang-hit-legend__label">HIT Meldung:</span>
        <span class="abgang-hit-legend__item abgang-hit-legend__item--ok">
            <svg aria-hidden="true" height="1em" viewBox="0 0 1 1" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path class="triangle-green" d="m 0 0 l 0 1 l 1 -1" />
            </svg>
            <span>erfolgreich</span>
        </span>
        <span class="abgang-hit-legend__item abgang-hit-legend__item--fail">
            <svg aria-hidden="true" height="1em" viewBox="0 0 1 1" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path class="triangle-red" d="m 0 0 l 0 1 l 1 -1" />
            </svg>
            <span>fehlgeschlagen</span>
        </span>
    </div>

    <div *ngIf="KieneUtils.isApiZero(tierliste?.mehrere_gruppen)" class="abgang-liste-toolbar">
        <button
            *ngIf="KieneUtils.apiStatusId(tierliste?.status_id, 161)"
            (click)="alleTiereZuAbgangslisteHinzufuegen()"
            [disabled]="(anzahlTiereZurListeHinzufuegbar ?? 0) < 1"
            class="abgang-liste-toolbar__primary"
            color="accent"
            mat-flat-button
            type="button"
        >
            Alle {{ anzahlTiereZurListeHinzufuegbar ?? 0 }} Tiere zur Liste hinzufügen
        </button>

        <div *ngIf="KieneUtils.apiStatusId(tierliste?.status_id, 161)" class="abgang-liste-toolbar__secondary">
            <button
                (click)="abgangslisteLeeren()"
                [disabled]="tiere.length <= 0"
                class="abgang-liste-toolbar__secondary-button"
                color="accent"
                mat-stroked-button
                type="button"
            >
                Liste leeren
            </button>
            <div class="abgang-liste-toolbar__icon-actions">
                <button
                    (click)="downloadAbgangsliste()"
                    aria-label="Ausstallliste herunterladen"
                    color="accent"
                    mat-icon-button
                    type="button"
                >
                    <mat-icon>download</mat-icon>
                </button>
                <button
                    (click)="ladeTiereFuerAbgangsliste('reload buton')"
                    aria-label="Liste aktualisieren"
                    color="accent"
                    mat-icon-button
                    type="button"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>

        <button
            *ngIf="KieneUtils.apiStatusId(tierliste?.status_id, 161) && !alsDialog && !hideListeAbschliessenButton"
            (click)="abgangslisteSchliessen()"
            [disabled]="tiere.length <= 0"
            class="abgang-liste-toolbar__primary"
            color="accent"
            mat-flat-button
            type="button"
        >
            Liste abschließen
        </button>
    </div>

    <div *ngIf="KieneUtils.isApiOne(tierliste?.mehrere_gruppen)" class="abgang-liste-toolbar">
        <div
            *ngIf="
                KieneUtils.apiStatusId(tierliste?.status_id, 161) &&
                KieneUtils.sameId(tierliste?.erstellt_von, lss.getCurrentUser().benutzer_id)
            "
            class="abgang-liste-toolbar__secondary"
        >
            <button
                (click)="abgangslisteLeeren()"
                [disabled]="tiere.length <= 0"
                class="abgang-liste-toolbar__secondary-button"
                color="accent"
                mat-stroked-button
                type="button"
            >
                Liste leeren
            </button>
            <div class="abgang-liste-toolbar__icon-actions">
                <button
                    (click)="downloadAbgangsliste()"
                    aria-label="Ausstallliste herunterladen"
                    color="accent"
                    mat-icon-button
                    type="button"
                >
                    <mat-icon>download</mat-icon>
                </button>
                <button
                    (click)="ladeTiereFuerAbgangsliste('reload buton')"
                    aria-label="Liste aktualisieren"
                    color="accent"
                    mat-icon-button
                    type="button"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>

        <button
            *ngIf="
                KieneUtils.apiStatusId(tierliste?.status_id, 161) &&
                KieneUtils.sameId(tierliste?.erstellt_von, lss.getCurrentUser().benutzer_id) &&
                !alsDialog &&
                !hideListeAbschliessenButton
            "
            (click)="abgangslisteSchliessen()"
            [disabled]="tiere.length <= 0"
            class="abgang-liste-toolbar__primary"
            color="accent"
            mat-flat-button
            type="button"
        >
            Liste abschließen
        </button>

        <p
            *ngIf="
                KieneUtils.apiStatusId(tierliste?.status_id, 161) &&
                !KieneUtils.sameId(tierliste?.erstellt_von, lss.getCurrentUser().benutzer_id)
            "
            class="abgang-liste-toolbar__info"
        >
            <mat-icon>info</mat-icon>
            <span
                >Abschlie&szlig;en oder leeren der Liste nicht m&ouml;glich. Sie sind nicht Besitzer dieser
                Liste.</span
            >
        </p>
    </div>

    <div class="abgang-liste-search">
        <mat-form-field class="abgang-liste-search__field">
            <mat-label>Ohrmarke suchen</mat-label>
            <input matInput [formControl]="suchfeldCtrl" placeholder="Ohrmarke eingeben..." />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="abgang-liste-tiere">
        <p *ngIf="isLoading">Tiere werden geladen...</p>
        <ng-container *ngFor="let tier of gefilterteTiere">
            <div class="abgang-liste-tiere__item">
                <kiene-gruppe-tier-card
                    [disableCardClickDetails]="true"
                    [hideAllButtons]="false"
                    [hideBemerkung]="true"
                    [hideKunde]="KieneUtils.isApiZero(tierliste?.mehrere_gruppen)"
                    [hideReklamationen]="true"
                    [tier]="tier"
                >
                    <ng-container additional-rows>
                        <div class="abgang-liste-tiere__remove-row">
                            <button
                                (click)="ausListeEntfernen(tier)"
                                *ngIf="KieneUtils.apiStatusId(tierliste?.status_id, 161)"
                                color="accent"
                                mat-stroked-button
                                type="button"
                            >
                                Tier aus Liste entfernen
                            </button>
                        </div>
                    </ng-container>
                </kiene-gruppe-tier-card>
            </div>
        </ng-container>
    </div>
</div>
